export const LocalStorageKeys = {
    ORDER_SCROLL_POSITION: 'orderScrollPosition',
    LAST_CREATE_BULK_INVOICE_ENTITY_ID: (userId: string) => `${userId}-lastCreateBulkInvoicesEntityId`,
    LAST_CREATE_BULK_INVOICE_TASK_ID: (userId: string) => `${userId}-lastCreateBulkInvoicesTaskId`
};
